import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=3cdc9f06&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc9f06",
  null
  
)

export default component.exports